import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import ArticleReaction from "./ArticleReaction";
import { sanitizeHtml } from "../../../../utils/sanitizeHtml";

const WORDS_PER_MINUTE = 200;

function getReadingMinutes(html) {
  if (!html) return 1;
  const text = String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&[a-z#0-9]+;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return 1;
  const words = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / WORDS_PER_MINUTE));
}

const ArticleContent = ({ article }) => {
  const readingMinutes = useMemo(
    () => getReadingMinutes(article?.content),
    [article?.content]
  );

  return (
    <React.Fragment>

      <Box
        sx={{
          display: "flex",
          gap: { xs: "6px", md: "10px" },
          alignItems: "center",
          marginBottom: { xs: "10px", md: "16px" },
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: { xs: "11px", sm: "12px", md: "14px" },
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            letterSpacing: { xs: "1.5px", md: "2.8px" },
            textTransform: "uppercase",
          }}
        >
          {article?.createdAt
            ? new Date(article.createdAt)
              .toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })
              .toUpperCase()
            : "OCTOBER 24, 2024"}
        </Box>
        <Box sx={{ color: "#405261" }}>•</Box>
        <Box
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: { xs: "11px", sm: "12px", md: "14px" },
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            letterSpacing: { xs: "1.5px", md: "2.8px" },
            textTransform: "uppercase",
          }}
        >
          {readingMinutes} MIN READ
        </Box>
      </Box>

      {/* Title */}
      <Box
        component="h1"
        sx={{
          color: "#0C141B",
          fontFamily: "Inter",
          fontSize: { xs: "32px", sm: "48px", md: "64px", lg: "84px" },
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: { xs: "40px", sm: "56px", md: "72px", lg: "94px" },
          marginTop: "0px",
          marginBottom: { xs: "16px", sm: "20px", md: "32px" },
          wordBreak: "break-word",
        }}
      >
        {article?.title || "TrustChat basics"}
      </Box>

      {/* Article Body */}
      <Box
        sx={{
          fontFamily: "Inter",
          fontSize: "16px",
          lineHeight: "28px",
          color: "#061522",
          whiteSpace: "pre-wrap",
          "& h1": { fontSize: "28px", fontWeight: 700, mt: 4, mb: 2 },
          "& h2": { fontSize: "24px", fontWeight: 600, mt: 3, mb: 2 },
          "& h3": { fontSize: "20px", fontWeight: 600, mt: 3, mb: 2 },
          "& p": { mb: 2 },
          "& div": { mb: 1 },
          "& ul, & ol": { pl: 4, mb: 2 },
          "& li": { mb: 1 },
          "& a": { color: "#148DFD", textDecoration: "none" },
          "& img": { maxWidth: "100%", borderRadius: "8px", my: 2 },
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(article?.content) }}
      />
      <Box
        sx={{
          width: "100%",
          height: "1px",
          background: "#E5E9EC",

        }}
      />
      {/* Tags */}
      <Box sx={{ marginTop: { xs: "30px", sm: "40px", md: "60px" }, marginBottom: { xs: "30px", sm: "40px", md: "60px" } }}>
        <Box
          sx={{
            color: "#0C141B",
            fontFamily: "Inter",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "34px",
            marginBottom: "20px",
          }}
        >
          Tags
        </Box>
        <Box sx={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          {(article?.tagIds && article.tagIds.length > 0
            ? article.tagIds
            : []
          ).map((tag, index) => (
            <Box
              key={index}
              sx={{
                height: "40px",
                padding: "0 16px",
                minWidth: "85px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50px",
                border: "1px solid #C5CED6",
                background: "#F9FAFA",
                boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                color: "#405261",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                boxSizing: "border-box",
              }}
            >
              {tag.name || tag}
            </Box>
          ))}
        </Box>
        {/* <Box
          sx={{
            width: "100%",
            height: "1px",
            background: "#E5E9EC",
            marginTop: "40px",
          }}
        /> */}
      </Box>

      <ArticleReaction articleId={article?._id} />
    </React.Fragment>
  );
};

export default ArticleContent;
